import { render, staticRenderFns } from "./FloatingButtonMenu.vue?vue&type=template&id=07b4dce4&scoped=true"
import script from "./FloatingButtonMenu.vue?vue&type=script&lang=js"
export * from "./FloatingButtonMenu.vue?vue&type=script&lang=js"
import style0 from "./FloatingButtonMenu.vue?vue&type=style&index=0&id=07b4dce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b4dce4",
  null
  
)

export default component.exports